import TrackChangesIcon from '@mui/icons-material/TrackChanges'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { pallete } from '../theme'
import { AuthorizationGate } from './components/Authorization'
import { Browser, Menu } from './components/achievements'

const layoutStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}

const contentStyle = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  padding: '8px'
}

const noDataStyle = { width: '100px', height: '100px', margin: 'auto', display: 'block', color: pallete.headerColor }

export const AllAchievements = () => {
  const data = useSelector((state) => state?.achievements?.all?.values)
  const navigation = useSelector((state) => state?.navigation)

  return (
    <Box sx={layoutStyle}>
      <Menu />
      <Box sx={contentStyle}>
        <Browser
          noData={{
            icon: <TrackChangesIcon sx={noDataStyle} className='get-achievements-icon'/>
          }}
          data={data}
          {...navigation}
        />
      </Box>
    </Box>
  )
}

export const UserAchievements = () => {
  const data = useSelector((state) => state?.achievements?.user?.values)
  const navigation = useSelector((state) => state?.navigation)

  return (
    <AuthorizationGate>
      <Box sx={layoutStyle}>
        <Menu />
        <Box sx={contentStyle}>
          <Browser
            noData={{
              label: 'nothing here - achievements',
              icon: <TrackChangesIcon sx={noDataStyle} className='get-achievements-icon'/>
            }}
            data={data}
            {...navigation}
          />
        </Box>
      </Box>
    </AuthorizationGate>
  )
}
